import actions from '@/vuex/actions/user-device'

export default {
  actions
}
